import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = false
}: CardProps) {
  return <div className={`
        bg-[#111827] border border-gray-800 rounded-xl p-6
        ${hoverEffect ? 'transition-all duration-300 hover:border-[#00d4aa]/50 hover:shadow-[0_0_30px_rgba(0,212,170,0.1)] hover:-translate-y-1' : ''}
        ${className}
      `} data-id="element-214">
      {children}
    </div>;
}